import { FunctionComponent } from "react";

import { DATE_FORMATS, DateTime } from "@bps/date-time";
import { ChangeLogDto } from "@libs/api/types/common-dtos";

interface ComponentDateTextProps {
  changeLog: ChangeLogDto;
}
export const ComponentDateText: FunctionComponent<ComponentDateTextProps> = ({
  changeLog
}) => {
  const date = changeLog?.updatedDate ?? changeLog?.createdDate ?? undefined;
  if (!date) return <>-</>;
  return (
    <>{DateTime.fromISO(date).toFormat(DATE_FORMATS.DETAILED_DATE_TIME)}</>
  );
};
